import { Link } from 'react-router-dom';
import { Briefcase } from 'lucide-react';
import { audiencePathsConfig as defaultAudiencePathsConfig } from '@/config';
import { useConfig } from '@/lib/siteData';
import { getIcon } from '@/lib/icons';

export function AudiencePaths({ index }: { index?: number } = {}) {
  const config = useConfig('audience_paths_config', defaultAudiencePathsConfig);
  const paths = config.paths?.length ? config.paths : defaultAudiencePathsConfig.paths;

  return (
    <section className="w-full py-16 md:py-20 bg-surface-gray border-t border-surface-border-gray">
      <div className="w-full max-w-[1200px] mx-auto px-6 lg:px-8">
        <div className="max-w-2xl mx-auto text-center mb-10">
          <span className="font-mono-label text-xs uppercase tracking-[0.2em] text-text-light">
            {index != null && <span className="text-accent-blue mr-1">{String(index).padStart(2, '0')} — </span>}
            {config.label}
          </span>
          <h2 className="font-geist-mono text-3xl md:text-[2.5rem] font-medium text-text-primary mt-3 leading-[1.1] tracking-tight">
            {config.heading}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {paths.map((path, i) => {
            const Icon = getIcon(path.iconName, Briefcase);
            return (
              <Link
                key={`${path.ctaHref}-${i}`}
                to={path.ctaHref}
                className="group block p-6 rounded-xl border border-surface-border-gray bg-surface-elevated hover:border-text-light/40 transition-colors duration-150"
              >
                <Icon className="w-6 h-6 text-accent-blue mb-4" />
                <h3 className="font-heading text-base font-semibold text-text-primary mb-2">
                  {path.title}
                </h3>
                <p className="font-body text-sm text-text-gray leading-relaxed mb-4">
                  {path.description}
                </p>
                <span className="text-accent-blue text-sm font-medium group-hover:underline">
                  {path.ctaLabel} →
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
